import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { distinctUntilChanged } from 'rxjs';
import { DropdownPosition } from 'src/app/components/shared/form/components/form-select/form-select.constants';
import { BUTTON_TYPES } from 'src/app/components/shared/modal/components/modal-frame/modal-frame.constants';
import { VALIDATION_MESSAGE } from 'src/app/components/shared/shared-constants';
import { SpecialCharacters } from 'src/app/core/enums';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { CONSTS, DEVICE_IDS, ENABLED_OPTIONS } from './add-device.constants';
import {
  AddDeviceAdmin,
  DeviceAdmin,
} from 'src/app/core/models/admin/device-admin.model';

@Component({
  selector: 'app-add-device',
  templateUrl: './add-device.component.html',
  styleUrls: ['./add-device.component.scss'],
  standalone: false,
})
export class AddDeviceComponent implements OnInit {
  deviceForm!: FormGroup;
  initialForm!: FormGroup;

  inputData = inject<AddDeviceAdmin>(MAT_DIALOG_DATA);
  commonUtils = inject(CommonUtils);
  private dialogRef = inject(MatDialogRef<AddDeviceComponent>);
  private fb = inject(FormBuilder);

  readonly CONSTS = { ...CONSTS, ...VALIDATION_MESSAGE };
  readonly REGEX = SpecialCharacters;
  readonly DropdownPosition = DropdownPosition;
  readonly IDS = DEVICE_IDS;
  readonly BUTTON_TYPES = BUTTON_TYPES;
  readonly STATUS_OPTIONS = ENABLED_OPTIONS;

  ngOnInit() {
    this.initiateForm(this.inputData?.editData);
  }

  initiateForm(returnData?: DeviceAdmin): void {
    this.deviceForm = this.getInitialForm(returnData);
    this.initialForm = this.getInitialForm(returnData);
  }

  onSubmit() {
    this.dialogRef.close({
      data: this.deviceForm.getRawValue(),
      isEdit: this.inputData.editMode,
      callApi: true,
    });
  }

  clearText() {
    this.deviceForm = this.getInitialForm(
      this.initialForm.getRawValue() as DeviceAdmin,
    );
    this.deviceForm.updateValueAndValidity();
  }

  clickExit() {
    this.commonUtils.openExitModal(
      AddDeviceComponent,
      null,
      this.deviceForm.dirty,
    );
  }

  trim(id: string) {
    const control = this.deviceForm.get(id);
    control?.setValue(control.value.trim());
  }

  private getInitialForm(returnData?: DeviceAdmin) {
    return this.fb.group({
      [DEVICE_IDS.EMPLOYEE_ID]: [returnData?.employeeId?.toUpperCase() ?? ''],
      [DEVICE_IDS.EMAIL]: [
        returnData?.email?.toUpperCase() ?? '',
        Validators.compose([Validators.required]),
      ],
      [DEVICE_IDS.LAST_NAME]: [
        returnData?.lastName?.toUpperCase() ?? '',
        Validators.compose([Validators.required]),
      ],
      [DEVICE_IDS.FIRST_NAME]: [
        returnData?.firstName?.toUpperCase() ?? '',
        Validators.compose([Validators.required]),
      ],
      [DEVICE_IDS.LOCATION]: [this.inputData.currLocation],
      [DEVICE_IDS.ENABLED]: [
        returnData?.enabled ?? true,
        Validators.compose([Validators.required]),
      ],
      //Non-editable
      [DEVICE_IDS.ID]: [returnData?.id],
      [DEVICE_IDS.LAST_LOGGED_IN]: [returnData?.lastLoggedIn],
      [DEVICE_IDS.INSERT_TIME]: [returnData?.insertTime],
      [DEVICE_IDS.ADDED_BY]: [returnData?.addedBy?.toUpperCase()],
    });
  }
}
